import { render, staticRenderFns } from "./Oggodata.vue?vue&type=template&id=91ab78b6&scoped=true&"
var script = {}
import style0 from "./Oggodata.vue?vue&type=style&index=0&id=91ab78b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ab78b6",
  null
  
)

export default component.exports